import { Navigate } from "react-router-dom";
import { useAccess } from "../../utils/hooks/access";

const TimeOffRedirect = () => {
    const { hasAccess: canViewMyTeamTimeOff } = useAccess("timeOff.canViewMyTeamTimeOff");

    return canViewMyTeamTimeOff ? <Navigate to="/time-off/team" replace /> : <Navigate to="/time-off/my" replace />;
};

export default TimeOffRedirect;
